import styled from "styled-components";
import { primaryFont, typeScale } from "utils";
export const Table = styled.table`
  width: 100%;
  height: auto;
  border-collapse: collapse;
  border-spacing: 0;
  background-color: ${(props) => props.theme.table.background};
  color: ${(props) => props.theme.table.color};
  font-family: ${primaryFont};
  font-size: 90%;
  margin-bottom: 1rem;
  input {
    width: 100%;
    height: auto;
    border: none;
    border-radius: 0;
    background-color: transparent;
    color: ${(props) => props.theme.table.color};
    font-family: ${primaryFont};
    padding: 0.5rem;
    &:focus {
      outline: none;
      
    }
  }
  th,
  td {
    text-align: left;
    padding: 0.5rem;
    border-spacing: 0;
    margin: 0;
    font-size: ${typeScale.smallParagraph};
    border-top: 1px solid ${(props) => props.theme.table.border};
    border-bottom: 1px solid ${(props) => props.theme.table.border};
    border-right: 1px solid ${(props) => props.theme.table.border};
  }
  thead {
    background-color: ${(props) => props.theme.table.thead.background};
    color: ${(props) => props.theme.table.thead.color};
    tr {
      border-top: 1px solid ${(props) => props.theme.table.border};
      border-bottom: 1px solid ${(props) => props.theme.table.border};
      border-right: 1px solid ${(props) => props.theme.table.border};
    }
  }
  tbody {
    tr {
      transition: all 0.1s ease-in-out;
      &:hover {
        background-color: ${(props) => props.theme.table.tr.hover.background};
        cursor: pointer;
      }
    }
  }
  td:first-child {
    border-left: 1px solid ${(props) => props.theme.table.border};
  }
  td:last-child {
    border-right: 1px solid ${(props) => props.theme.table.border};
  }
  td:first-child,
  td:last-child {
    border-bottom: 1px solid ${(props) => props.theme.table.border};
  }
`;
